export const DropdownMode = {
	MY_STUDIOS: 'My Studios',
	CHANNEL_STUDIOS: 'Other channel studios',
};
